/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GoInputs */

const en_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go`)
};

const es_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir`)
};

const fr_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller`)
};

const de_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los`)
};

const ja_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進む`)
};

const zh_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往`)
};

const ar_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انطلاق`)
};

const id_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const it_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai`)
};

const ru_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти`)
};

const pt_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir`)
};

const ko_go = /** @type {(inputs: GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이동`)
};

/**
* | output |
* | --- |
* | "Go" |
*
* @param {GoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go = /** @type {((inputs?: GoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go(inputs)
	if (locale === "es") return es_go(inputs)
	if (locale === "fr") return fr_go(inputs)
	if (locale === "de") return de_go(inputs)
	if (locale === "ja") return ja_go(inputs)
	if (locale === "zh") return zh_go(inputs)
	if (locale === "ar") return ar_go(inputs)
	if (locale === "id") return id_go(inputs)
	if (locale === "it") return it_go(inputs)
	if (locale === "ru") return ru_go(inputs)
	if (locale === "pt") return pt_go(inputs)
	return ko_go(inputs)
});